<template>
  <div class="footer w-100 p-3">
    <div
      class="d-flex justify-content-around align-items-center"
      v-if="readingExperience.currentStage === 'bookReading'"
    >
      <div>
        <button
          class="btn br-button-primary m-0 px-4 py-1 border-radius-5 font-2-em"
          @click="back"
        >
          <i class="fas fa-chevron-left"></i> Anterior
        </button>
      </div>
      <div>
        <span class="text-upppercase text-center font-3-em"
          >Página {{ readingExperience.currentPage }} /
          {{ readingExperience.bookData.structTotalPages }}</span
        >
      </div>
      <div>
        <button
          class="btn br-button-primary m-0 px-4 py-1 border-radius-5 font-2-em"
          @click="next"
        >
          Siguiente
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "br-footer",
  data() {
    return {};
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
  methods: {
    ...mapMutations(["nextPage", "backPage"]),
    ...mapActions(["moveLeft", "moveRigth"]),
    next() {
      window.scrollTo(0, 0);
      this.moveRigth();
    },
    back() {
      window.scrollTo(0, 0);
      this.moveLeft();
    },
  },
};
</script>
